var React = require('react');

function PlayButton (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"46.5","cy":"46.5","r":"46","fill":"white","stroke":"#623491","key":0}),React.createElement("path",{"d":"M33.6241 68.0831L33.6241 22.5966L68.6594 45.3398L33.6241 68.0831Z","fill":"#623491","key":1})]);
}

PlayButton.defaultProps = {"width":"93","height":"93","viewBox":"0 0 93 93","fill":"none"};

module.exports = PlayButton;

PlayButton.default = PlayButton;
